import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { DEVICE_ICON_COLOR } from 'app/shared/components/icons/ds-icons.constants';

const GATEWAY_ICON_BASE_PATH = 'assets/img/devices/ic_Box/';

const PIN_PREFIX_TO_ICON: Readonly<Record<string, string>> = {
    '02': 'ic_tahoma_V1_xlarge.svg',
    '04': 'ic_connexoon_xlarge.svg',
    '08': 'ic_connexoon_xlarge.svg',
    '10': 'ic_din_rail_xlarge.svg',
    '11': 'ic_taHoma_v2_xlarge.svg',
    '12': 'ic_taHoma_v2_xlarge.svg',
    '16': 'ic_tahoma_beecon_xlarge.svg',
    '20': 'ic_taHoma_switch_xlarge.svg',
    '21': 'ic_taHoma_mini_xlarge.svg',
    '22': 'ic_din_railV2_xlarge.svg',
    '23': 'ic_taHoma_switch_xlarge.svg',
};

const FALLBACK_ICON = 'ic_generic_xlarge.svg';

@Component({
    selector: 'app-gateway-icon',
    templateUrl: './gateway-icon.component.html',
    styleUrl: './gateway-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { '[class.skeleton-icon]': 'loading()' },
})
export class GatewayIconComponent {
    readonly gatewayId = input<string>();
    readonly loading = input(false);
    readonly nbBoxes = input(1);
    readonly variant = input(DEVICE_ICON_COLOR.YELLOW);

    protected readonly iconPath = computed(() => {
        const prefix = this.gatewayId()?.substring(0, 2);

        return GATEWAY_ICON_BASE_PATH + (prefix ? (PIN_PREFIX_TO_ICON[prefix] ?? FALLBACK_ICON) : FALLBACK_ICON);
    });
}
